import { useParams, useSearchParams } from "react-router-dom";
import { useProducts } from "../../hooks/common-hooks/useProducts";
import StyledProducts from "./StyledProducts";
import { renderProductInfo } from "./productInfo";
import renderNoDataHelper from "../../utils/renderNoDataHelper";
import renderProductsLoadingHelper from "../../utils/renderProductsLoadingHelper";
import ProductList from "../../components/CommonComponents/Products";

const CollectionPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");
  const search = searchParams.get("search");
  const {
    products = [],
    loading,
    setCount,
    isViewMoreVisible,
    productsContainerRef,
    pageDetails,
    isError,
  } = useProducts(
    `?${search ? `search=${search}` : ""}${id ? `&collection=${id}` : ""}${category ? `&category=${category}` : ""}`,
  );

  const getTitle = () => {
    if (id?.length) {
      return products?.[0]?.collection_name;
    } else {
      return search;
    }
  };

  return (
    <StyledProducts>
      {renderProductsLoadingHelper(loading)}
      {renderNoDataHelper(products)}
      {renderProductInfo(products, pageDetails, getTitle())}
      <ProductList
        products={products}
        setCount={setCount}
        isViewMoreVisible={isViewMoreVisible}
        productsContainerRef={productsContainerRef}
        pageDetails={pageDetails}
        loading={loading}
        isError={isError}
      />
    </StyledProducts>
  );
};

export default CollectionPage;
